// Android WebView 83 support: @angular/core, common, forms, router and localize all call
// Object.hasOwn (Chrome 93) during bootstrap, and esbuild never polyfills. See AGENTS.md
// before adding anything else here - the initial bundle is budget-constrained.
if (!Object.hasOwn) {
    (Object as { hasOwn?: unknown }).hasOwn = (target: object, key: PropertyKey): boolean => Object.prototype.hasOwnProperty.call(target, key);
}
